/*
	The default config should typically be set as the values of
	the main solution. These can then be overwritten by the values
	coming from backend or solution-specific files (handled in the
	ThemeConfiguration.vue component).

	Only the keys in this default file will be the grounds for tailwind
	rules - overwriting configurations should never introduce new keys,
	unless they are added to this file too. Only the values of the keys
	are overwritten.
*/
export default {
	// Testing only - set to false when done testing
	minify: true, // Can be turned to false for a more readable output in the style tag

	// Setup
	baseFontSize: 16, // For rem conversion
	smViewport: 568, // Lowest value clamp
	mdViewport: 760, // Midpoint (used for both low-clamp and high-clamp)
	lgViewport: 990, // Highest value clamp

	// Rules
	colors: {
		/*
			CSS variables will be created and used for the colors,
			which will in turn be used in the Tailwind config. Keys
			will be directly transfered to the Tailwind config.

			"primary: '#000000'" will result in the Tailwind rule:
			"primary: var(--theme-colors-primary, #000000)"

			If configuring a color with three comma-separated numbers,
			the built-in Tailwind color opacities will be used in the
			rules.
		*/
	},

	layout: {
		margin: {
			sm: 15,
			md: 20,
			lg: 20,
		},

		gutter: {
			sm: 10,
			md: 10,
			lg: 10,
		},

		// These rules will be turned into `X/Ycol` rules, which can then be used like `w-3/12col`.
		// There should always be at least one column, both on sm, md and lg.
		columns: {
			sm: 6,
			md: 6,
			lg: 6,
		},

		// The max value that the design can be scaled to (single value, not sm-md-lg).
		// The max will impact columns max scaling as well.
		// undefined equals no max.
		max: 990,
	},

	spacing: {
		'box-padding': {
			sm: 15,
			md: 25,
			lg: 25,
		},
		// 'sm': {
		// 	sm: 16,
		// 	md: 16,
		// 	lg: 20,
		// },
	},
	horizontalSpacing: {
		// 'sm/h': {
		// 	sm: 16,
		// 	md: 16,
		// 	lg: 20,
		// },
	},
	verticalSpacing: {
		// 'sm/v': {
		// 	sm: 16,
		// 	md: 16,
		// 	lg: 20,
		// },
	},

	// fontSize (and lineHeight and letterSpacing) is a special setup, as special rules are generated
	fontSize: {
		h1: {
			fontSize: {
				sm: 25,
				md: 35,
				lg: 45,
			},
			// 	lineHeight: {
			// 		sm: 1.2,
			// 		md: 1.2,
			// 		lg: 1.2,
			// 	},
			// 	letterSpacing: {
			// 		sm: -0.5,
			// 		md: -1,
			// 		lg: -0.5,
			// 	},
		},
	},

	borderRadius: {
		/* to be added */
	},
};
